import React from 'react'

import AbsolutePageTemplate from '../../../components/templates/AbsolutePageTemplate'
import BucketLoader from './_load/BucketLoader'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import PdfOptionsFormHandler from '../../../components/pdf/options/_form/PdfOptionsFormHandler'
import { NO_TEMPLATE } from './_templates/Constants'

const initialState = {
  qrcodeSize: 5,
  qrcodeTop: 4,
  qrcodeLeft: 1,
  qrcodePadding: 0.3,
  templateWidth: 16,
  template: NO_TEMPLATE,
  logoAlign: { name: 'À esquerda', id: 'start' },
  logoSpacing: 0.5,
  title: 'Como está sendo sua experiência conosco?',
  titleSize: 30,
  titleAlign: { name: 'À esquerda', id: 'left' },
  titleColor: '#ffffff',
  subtitle: 'Aponte a câmera para esse QR Code e conta mais para gente!',
  subtitleSize: 22,
  subtitleSpacing: 0.5,
  subtitleAlign: { name: 'À esquerda', id: 'left' },
  subtitleColor: '#ffffff',
  bgColor: '#536192',
  activationDetails: true
}

const EditQrCodeTemplatePage = ({ id }) => {
  return (
    <BucketLoader id={id}>
      <PdfOptionsFormHandler initialState={initialState}>
        <AbsolutePageTemplate>
          <PageHeader />
          <PageContent />
        </AbsolutePageTemplate>
      </PdfOptionsFormHandler>
    </BucketLoader>
  )
}

export default EditQrCodeTemplatePage
